var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorTravelAgency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.013,
    y: 26.257,
    width: 5.257,
    height: 11.818,
    transform: "translate(-15.533 9.944) rotate(-31.879)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.921,27.795h5.331c1.467,0,2.657-1.19,2.657-2.657h0c0-1.467-1.19-2.657-2.657-2.657h-8.554c-1.431,0-2.814.515-3.896,1.452l-3.944,3.413,4.018,6.799h10.774c2.575,0,5.045-1.023,6.867-2.844l6.745-6.745c1.038-1.038,1.038-2.72,0-3.757h0c-1.038-1.038-2.72-1.038-3.757,0l-6.423,6.423c-.368.368-.866.574-1.386.574"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.189,12.404l-1.244-.668c-.806-.433-1.706-.659-2.621-.659h-9.494S15.064,3.428,15.064,3.428h-4.41s6.71,7.649,6.71,7.649H7.777s-2.608-2.37-2.608-2.37h-2.209s2.195,5.293,2.195,5.293c.508,1.226,1.705,2.025,3.032,2.025h25.264c1.503,0,2.998-.219,4.438-.651h0c1.379-.414,1.569-2.288.3-2.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorTravelAgency);
export default __webpack_public_path__ + "static/media/indoor-travel_agency.3731336e07d97be63c3a67a660d19c40.svg";
export { ForwardRef as ReactComponent };